"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormSubmit = void 0;
const react_1 = require("react");
const helpers_1 = require("./helpers");
const store_1 = require("./store");
function useFormSubmit(name) {
    const state = (0, store_1.useFormStoreState)(name);
    return (0, react_1.useMemo)(() => (0, helpers_1.formStateWithHelpers)(state), [state]);
}
exports.useFormSubmit = useFormSubmit;
//# sourceMappingURL=use-form-submit.js.map